module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMy4yMTEgMjAuODcxIj4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgZmlsbDogI2ZmZjsNCiAgICAgIH0NCiAgICA8L3N0eWxlPg0KICA8L2RlZnM+DQogIDxwYXRoIGlkPSJyZWNvbW1lbmNlciIgY2xhc3M9ImNscy0xIiBkPSJNMTYuMjU0LDEwLjQzNWwzLjQ3OCwzLjQ3OCwzLjQ3OC0zLjQ3OEgyMC44NzdhMTAuNDU1LDEwLjQ1NSwwLDEsMC0yLjUsNi43NjVMMTYuNzMsMTUuNTU0YTguMTEyLDguMTEyLDAsMSwxLDEuODI2LTUuMTE5aC0yLjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recommencer.svg
// module id = 5N9E
// module chunks = 1